import { combineReducers } from "redux";

import flexgeReducers from "student-front-commons/src/reducers";

export default combineReducers({
  ...flexgeReducers,
});
